import React from 'react';
import { ItemType } from '../../../shared/interfaces';
import Notepad from '../../general/Notepad';
import { useItemNotes } from '../../../hooks/useItemNotes';
import { useCanEditNotes } from '../../../hooks/useCanEditNotes';

interface NotepadWrapperProps {
  itemId: string;
  itemType: ItemType;
  isFence?: boolean;
  ownerTitle?: string;
}

const NotepadWrapper: React.FC<NotepadWrapperProps> = ({
  itemId,
  itemType,
  isFence = false,
  ownerTitle
}) => {
  const deviceOrFence = isFence ? 'fence' : 'device';
  const notes = useItemNotes(deviceOrFence, itemId);
  const { disabled } = useCanEditNotes(itemId, itemType);

  return (
    <Notepad
      notes={notes}
      deviceOrFence={deviceOrFence}
      deviceOrFenceId={itemId}
      ownerTitle={ownerTitle}
      disabled={disabled}
    />
  );
};

export default NotepadWrapper;